import {
	includedPropList,
	includedT2PropList,
} from "../../../pages/activityBuilder/modules/smallFisheries/smallFisheries";
import type {
	SmallFisheriesResponse,
	ModuleFull,
} from "../../../pages/activityBuilder/modules/smallFisheries/smallFisheriesTypes";
import { FEModules } from "../../../utils/moduleList";
import { FEModulesObj } from "../../../utils/moduleList";
import { apiSlice, publicApiSlice, TagTypes } from "../../apiSlice";
import { createModuleGetApi, createModuleUpdateApi } from "./factories/createModuleApi";
import { transformModuleResponse, prepareModulePayload } from "./factories/moduleApiUtils";

// Define constants for the module
const MODULE_TYPE = "SmallFisheries";
const TAG: TagTypes = "SmallFisheries";
const TAG_DEFAULTS: TagTypes = "SmallFisheriesDefaults";
const ENDPOINT = FEModulesObj[FEModules.SmallFisheries].path;

const t1PercentageProps = ["ice_preserved_catch_pc", "refrigerant_pc"];

const transformResponse = (response: SmallFisheriesResponse) => transformModuleResponse<SmallFisheriesResponse, ModuleFull>({
	response,
	includedPropList,
	includedT2PropList,
	percentageProps: t1PercentageProps
})

const smallFisheryApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

const publicSmallFisheryApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice: publicApiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

const transformUpdatePayload = (data: ModuleFull, activityId: number) => prepareModulePayload({
	moduleData: data.module,
	tiertwoData: data.tiertwo,
	percentageProps: t1PercentageProps,
	activityId
})

const mutationApiSlice = createModuleUpdateApi<ModuleFull, SmallFisheriesResponse>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformUpdatePayload,
})

export const {
	useGetSmallFisheriesQuery,
	useGetSmallFisheriesDefaultsQuery
} = smallFisheryApiSlice;

export const {
	useGetSmallFisheriesQuery: usePublicGetSmallFisheriesQuery,
	useGetSmallFisheriesDefaultsQuery: usePublicGetSmallFisheriesDefaultsQuery,
} = publicSmallFisheryApiSlice;

export const {
	useUpdateSmallFisheriesMutation,
} = mutationApiSlice;
